export class QuayKeyValuesEditFailed extends Error {}
